module.exports = __webpack_public_path__ + "img/adult-primal-runamoc-blue.41a6cf42.jpg";